import { render, staticRenderFns } from "./PainterMakeOrder.vue?vue&type=template&id=189d181c&scoped=true"
import script from "./PainterMakeOrder.vue?vue&type=script&lang=js"
export * from "./PainterMakeOrder.vue?vue&type=script&lang=js"
import style0 from "./PainterMakeOrder.vue?vue&type=style&index=0&id=189d181c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d181c",
  null
  
)

export default component.exports